import React from 'react';
import FilterTable from './filterTable';
import { OfflineLicenseColumnCaptions } from './tableColumnCaptions';
import FavoriteItemColumnFormatter from './favoriteItemColumnFormatter';
import {versionSort} from '../common/arraySort';

const OfflineLicenseTable = props => {
  let productNameFilterValues = { 'all': '' };
  props.products.forEach(product => productNameFilterValues[product.name] = product.name);
  let livingStateFilterValues = { 'all': '' };
  props.livingStates.forEach(livingState => livingStateFilterValues[livingState] = livingState);
  let dicomConnectionLimitationTypesValues = { 'all': '' };
  props.dicomConnectionLimitationTypes.forEach(i => dicomConnectionLimitationTypesValues[i.name] = i.code);

  const columns = [{
    dataField: 'key',
    text: OfflineLicenseColumnCaptions.key,
    sort: true,
    filter_: { type: 'text' },
    headerStyle: () => ({width: '17em'})
  }, {
    dataField: 'productName',
    text: OfflineLicenseColumnCaptions.productName,
    sort: true,
    filter_: {
      type: 'select',
      values: productNameFilterValues
    },
    headerStyle: () => ({width: '7em'})
  }, {
    dataField: 'device.key',
    text: OfflineLicenseColumnCaptions.device.key,
    sort: true,
    filter_: { type: 'text' },
    headerStyle: () => ({width: '12em'})
  }, {
    dataField: 'generationDate',
    text: OfflineLicenseColumnCaptions.generationDate,
    sort: true,
    filter_: {type: 'datetime'},
    headerStyle: () => ({width: '11em'})
  }, {
    dataField: 'activationDate',
    text: OfflineLicenseColumnCaptions.activationDate,
    sort: true,
    filter_: {type: 'datetime'},
    headerStyle: () => ({width: '7em'})
  }, {
    dataField: 'supportExpirationDate',
    text: OfflineLicenseColumnCaptions.supportExpirationDate,
    sort: true,
    filter_: {type: 'datetime'},
    headerStyle: () => ({width: '7em'})
  }, {
    dataField: 'maxProductVersion',
    text: 'Max version',
    sort: true,
    filter_: { type: 'text' },
    sortFunc: (a, b, order) => versionSort(3, a, b, order)
  }, {
    dataField: 'connectionCount',
    text: OfflineLicenseColumnCaptions.connectionCount,
    filter_: { type: 'text' },
    sort: true,
    headerStyle: () => ({width: '7em'})
  }, {
    dataField: 'webConnectionCount',
    text: OfflineLicenseColumnCaptions.webConnectionCount,
    filter_: { type: 'text' },
    sort: true,
    headerStyle: () => ({width: '7em'})
  }, {
    dataField: 'webExpirationDate',
    text: OfflineLicenseColumnCaptions.webExpirationDate,
    filter_: { type: 'text' },
    sort: true,
    headerStyle: () => ({width: '7em'})
  },  {
    dataField: 'dicomConnectionLimitationType',
    text: OfflineLicenseColumnCaptions.dicomConnectionLimitationType,
    filter_: {
      type: 'select',
      values: dicomConnectionLimitationTypesValues
    },
    sort: true,
    headerStyle: () => ({width: '7em'}),
    formatter: (cell) => {
      const item = props.dicomConnectionLimitationTypes.find((i) => i.code === cell);
      return item ? item.name : '';
    }
  }, {
    dataField: 'client.fullName',
    text: OfflineLicenseColumnCaptions.client.fullName,
    filter_: { 
      type: 'text',
      searchable: true,
    },
    sort: true,
  }, {
    dataField: 'livingState',
    text: OfflineLicenseColumnCaptions.livingState,
    sort: true,
    filter_: {
      type: 'select',
      values: livingStateFilterValues
    },
    headerStyle: () => ({width: '6em'})
  }, {
    dataField: 'isFavorite',
    text: OfflineLicenseColumnCaptions.isFavorite,
    sort: false,
    align: 'center',
    filter_: {
      type: 'select',
      values: {
        'all': '',
        'favorite': 'true',
      }
    },
    headerStyle: () => ({width: '35px'}),
    formatter: (cell, row) => <FavoriteItemColumnFormatter
      cell={cell} row={row}
      actions={props.actions}/>,
  }];

  const defaultSorted = [{
    dataField: 'generationDate',
    order: 'desc'
  }];

  return (
    <FilterTable
      key={props.dicomConnectionLimitationTypes.length} // не работает реактивность в форматтере, key нужен для перерендера при обновлении пропса
      {...props}
      objectName={'offlineLicenses'}
      data={props.offlineLicenses}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no offline licenses"
    />
  );
};

export default OfflineLicenseTable;



// WEBPACK FOOTER //
// ./src/components/offlineLicenseTable.js